angular
    .module('app')
    .component('contracts', {
        templateUrl: '/templates/pages/contracts/contracts.html',
        controller: 'ContractsController',
        controllerAs: 'vm',
    });